import React, { createContext, useContext } from "react";

import type { RadioGroupOnChangeData } from "@fluentui/react-components";
import type { PerfReport } from "src/services";
import type { ClassificationProgressEvent } from "src/types";

/** Outcome of a completed styling run; undefined if the run bailed out early with no result. */
export type ClassifyDocumentResult = { warning: string | null } | undefined;

type ProfileContextType = {
  classificationStatus: string | null;
  classificationEta: string | null;
  isClassifying: boolean;
  lockExistingStyles: boolean;
  isRunning: boolean;
  pendingSelection: string | null;
  /** Timing breakdown of the last styling run; null until one completes. */
  perfReport: PerfReport | null;
  progress: Pick<ClassificationProgressEvent, "completed" | "total"> | null;
  stagedProfileName: string | null;
  commitProfile: () => Promise<string | null>;
  handleClassifyDocument: (
    onStylingComplete?: () => void
  ) => (profileName?: string) => Promise<ClassifyDocumentResult>;
  handleSetProfile: (ev: React.FormEvent<HTMLDivElement>, data: RadioGroupOnChangeData) => void;
  setLockExistingStyles: (value: boolean) => void;
};

const ProfileContext = createContext<ProfileContextType>({} as ProfileContextType);

export const useProfileContext = () => {
  return useContext(ProfileContext);
};

export default ProfileContext;

